import { tile_groups_helper } from "@/helpers/tile_groups_helper";

const defaultConfig = {
  groupsKey: "tile_groups",
};

/**
 *
 * @param page
 * @param config
 * @param props
 * @returns {{component: string, props: (*&{title: (*|null), items: *})}|null}
 */
export const tileGroups = ({ page, config, ...props }) => {
  config = Object.assign({}, defaultConfig, config);

  if (!page || !(config.groupsKey in page) || page[config.groupsKey].length === 0) {
    return null;
  }

  const groupNames = page[config.groupsKey].split(",").map((g) => g.trim().toLowerCase());
  const groups = tile_groups_helper.filter((g) => groupNames.includes(g.name.trim().toLowerCase()));

  return {
    component: "TileGroups",
    props: {
      groups: groups.map((g) => ({
        title: g.title ?? null,
        items: g.items.map((i) => ({
          label: i.label ?? null,
          image: i.image ?? "",
          url: i.url ?? "#",
        })),
        footer_links: g.footer_links ?? null,
      })),
      ...props,
    },
  };
};
